import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { combineReducers } from "@reduxjs/toolkit";
import authenticationReducer from "../features/authentication/authenticationSlice";
import i18nReducer from "../features/localization/localizationSlice";
import sessionsReducer from "../features/sessions/sessions-slice";
import waitlistReducer from "../features/sessions/waitlist-slice";
import seatsReducer from "../features/sessions/seats-slice";
import accountDeletionReducer from "../features/account-deletion/account-deletion-slice";
import deletionRequestsReducer from "../features/deletion-requests/deletion-requests-slice";
import visitsReducer from "../features/sessions/visits-slice";
import occurrencesReducer from "../features/sessions/occurrences-slice";
import membersReducer from "../features/members/members-slice";
import themeReducer from "../features/theme/themeSlice";
import instructorPreferencesReducer from "../features/instructor-preferences/instructor-preferences-slice";
import paymentTypesReducer from "../features/payment-types/payment-types-slice";
import contractsReducer from "../features/contracts/contracts-slice";
import paymentsReducer from "../features/payments/payments-slice";
import closedPeriodsReducer from "../features/closed-periods/closed-periods-slice";
import billingReducer from "../features/billing/billing-slice";
import calendarReducer from "../features/calendar/calendar-slice";
import closedDaysReducer from "../features/closed-days/closed-days-slice";
import subscriptionReducer from "../features/subscription/subscription-slice";
import instructorConsentReducer from "../features/instructor-consent/instructor-consent-slice";
import adminReducer from "../features/admin/admin-slice";
import referralsReducer from "../features/referrals/referrals-slice";
import feedbackReducer from "../features/feedback/feedback-slice";
import searchReducer from "../features/search/search-slice";
import instructorsReducer from "../features/instructors/instructors-slice";
import organizationReducer from "../features/organization/organization-slice";
import assistantImportReducer from "../features/assistant-import/assistant-import-slice";
import assistantScheduleReducer from "../features/assistant-schedule/assistant-schedule-slice";
import portalReducer from "../features/portal/portal-slice";
import portalMoneyReducer from "../features/portal/portal-money-slice";
import trialRequestsReducer from "../features/trial-requests/trial-requests-slice";
import contactMessagesReducer from "../features/contact-messages/contact-messages-slice";
import announcementsReducer from "../features/announcements/announcements-slice";
import collectionReducer from "../features/collection/collection-slice";
import businessProfileReducer from "../features/business-profile/business-profile-slice";
import absencesReducer from "../features/absences/absences-slice";
import materialsReducer from "../features/materials/materials-slice";
import messagesReducer from "../features/messages/messages-slice";
import portalSettingsReducer from "../features/portal-settings/portal-settings-slice";
import sampleDataReducer from "../features/sample-data/sample-data-slice";
import trainingReducer from "../features/training/training-slice";
import bookableSlotsReducer from "../features/bookable-slots/bookable-slots-slice";
import contextsReducer from "../features/contexts/contexts-slice";
import { injectStore } from "../features/axiosInstance/axiosInstance";
import { injectMessagesHubTokenSource } from "../features/messages/live/messagesHubClients";
import { dateSerializableConfig } from "./middleware";

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  i18n: i18nReducer,
  sessions: sessionsReducer,
  waitlist: waitlistReducer,
  seats: seatsReducer,
  accountDeletion: accountDeletionReducer,
  deletionRequests: deletionRequestsReducer,
  visits: visitsReducer,
  occurrences: occurrencesReducer,
  members: membersReducer,
  theme: themeReducer,
  instructorPreferences: instructorPreferencesReducer,
  paymentTypes: paymentTypesReducer,
  contracts: contractsReducer,
  payments: paymentsReducer,
  closedPeriods: closedPeriodsReducer,
  billing: billingReducer,
  calendar: calendarReducer,
  closedDays: closedDaysReducer,
  subscription: subscriptionReducer,
  instructorConsent: instructorConsentReducer,
  admin: adminReducer,
  referrals: referralsReducer,
  feedback: feedbackReducer,
  search: searchReducer,
  instructors: instructorsReducer,
  organization: organizationReducer,
  assistantImport: assistantImportReducer,
  assistantSchedule: assistantScheduleReducer,
  portal: portalReducer,
  portalMoney: portalMoneyReducer,
  trialRequests: trialRequestsReducer,
  contactMessages: contactMessagesReducer,
  announcements: announcementsReducer,
  collection: collectionReducer,
  businessProfile: businessProfileReducer,
  absences: absencesReducer,
  materials: materialsReducer,
  messages: messagesReducer,
  portalSettings: portalSettingsReducer,
  sampleData: sampleDataReducer,
  training: trainingReducer,
  bookableSlots: bookableSlotsReducer,
  contexts: contextsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: dateSerializableConfig,
    }),
});

injectStore(store);
// The messages hub opens with the same instructor token the axios instance sends.
injectMessagesHubTokenSource(() => store.getState().authentication.userAuth?.access_token);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
